import styled from 'styled-components'

const ListElementStyle = styled.div`
  .listItem {
    background: #fff;
    width: 100%;
    height: 56px;
    display: grid;
    grid-template-columns: 1fr 24px;
    grid-column-gap: 16px;
    margin-bottom: 4px;
    padding: 0 12px 0 24px;
    border-radius: 3px;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  }

  .listItem:hover {
    border-left: 5px solid ${props => props.theme.palette.primary.main};
    padding: 0 12px 0 19px;
  }
`

export default ListElementStyle
